import { ComputeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Compute')
export class ComputeNodeSchemaProvider extends SchemaProvider<ComputeWorkflowNode> {}
